var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480.23 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#687389;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.07,432h32v16h-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.07,200h32v16h-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.07,120h-8V104h-16v16h-22.4c-19.2-27.2-44.8-48.8-73.6-64.8V24a23.57,23.57,0,0,0-24-24h-144a23.57,23.57,0,0,0-24,24V55.2a209.33,209.33,0,0,0-84,80.8c-35.2,2.4-61.6,32.8-60,68a65.49,65.49,0,0,0,32.8,52,218.35,218.35,0,0,0,12,56,47.54,47.54,0,0,0-12.8,66.4c1.6,2.4,4,4.8,5.6,7.2L72.07,420l26.4-26.4a203.3,203.3,0,0,0,45.6,32V456a23.57,23.57,0,0,0,24,24h144a23.57,23.57,0,0,0,24-24V424.8c12-6.4,22.4-12.8,32.8-21.6,24,26.4,64,28,90.4,4s28-64,4-90.4c-6.4-7.2-15.2-12.8-24-16.8a228.15,228.15,0,0,0,8.8-52h8a23.57,23.57,0,0,0,24-24V144a23.57,23.57,0,0,0-24-24Zm8,24v8h-96v-8a7.56,7.56,0,0,1,8-8h80A7.56,7.56,0,0,1,464.07,144Zm-304-120a7.56,7.56,0,0,1,8-8h144a7.56,7.56,0,0,1,8,8v80a7.56,7.56,0,0,1-8,8h-51.2l-20.8,20.8L219.27,112h-51.2a7.56,7.56,0,0,1-8-8Zm-144,176a48,48,0,1,1,48,48A48.14,48.14,0,0,1,16.07,200Zm56,196.8-22.4-22.4c-12-12-12-32,0-44.8a32.08,32.08,0,0,1,22.4-9.6h.8a31.24,31.24,0,0,1,31.2,31.2c0,8-3.2,16.8-9.6,22.4Zm248,3.2h-160V192a7.56,7.56,0,0,1,8-8h144a7.56,7.56,0,0,1,8,8Zm-8,64h-144a7.56,7.56,0,0,1-8-8V416h160v40A7.56,7.56,0,0,1,312.07,464Zm152-104a48,48,0,1,1-48-48A48.14,48.14,0,0,1,464.07,360Zm-40.8-63.2c-35.2-4-67.2,20.8-71.2,56a61.41,61.41,0,0,0,7.2,37.6,238.12,238.12,0,0,1-23.2,16V192a23.57,23.57,0,0,0-24-24h-144a23.57,23.57,0,0,0-24,24V406.4a213.31,213.31,0,0,1-34.4-25.6c16-20.8,12.8-50.4-8-66.4A47.53,47.53,0,0,0,72.07,304h-.8a61.75,61.75,0,0,0-12,1.6c-4.8-13.6-8.8-28.8-10.4-43.2a64,64,0,1,0,28.8-124.8h-.8a195.54,195.54,0,0,1,66.4-64V104a23.57,23.57,0,0,0,24,24h44.8l27.2,27.2,27.2-27.2h45.6a23.57,23.57,0,0,0,24-24V73.6a187.26,187.26,0,0,1,53.6,46.4h-13.6a23.57,23.57,0,0,0-24,24v80a23.57,23.57,0,0,0,24,24h56a201.73,201.73,0,0,1-8.8,48.8Zm32.8-64.8h-80a7.56,7.56,0,0,1-8-8V168h96v56A7.56,7.56,0,0,1,456.07,232Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.87,209.6,72.07,196V168h-16v36l27.2,18.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.07,184h16v32h-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.07,184h16v32h-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.07,432h64v16h-64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.07,40h96V56h-96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.07,80h96V96h-96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.07,328h16v32h-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.07,376h16v16h-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.07,40h16V56h-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.07,80h16V96h-16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.adfb74bdb7450d3df9231ced52071dd0.svg";
export { ForwardRef as ReactComponent };